<template>
	<div style="width:210mm">
		<div style="width:210mm;height:8mm;font-size:14pt;font-weight:bold;text-decoration:underline;text-align: center;">
			<span>收 款 收 据</span>
		</div>
		<div style="width:167mm;height:8mm;font-size:12pt;margin:0 auto;">
			
			<div style="float:left;">
				收款单位：<span style="text-decoration:underline">拙诚燃气公司</span>
			</div>
			<div style="float:right;">
				NO.<span style="text-decoration:underline">000633</span>
			</div>
			<div style="margin-left:70mm;">
				<span style="text-decoration:underline">{{nowDate.getFullYear()}}</span>年
				<span style="text-decoration:underline">{{nowDate.getMonth() + 1}}</span>月
				<span style="text-decoration:underline">{{nowDate.getDate()}}</span>日
			</div>
		</div>
		<div class="div">
			<Row>
		        <Col class="col center" span="3">
		        		户名
		        </Col>
		        <Col class="col center" span="9">
		        		19032500000005
		        </Col>
		        <Col class="col center" span="3">
		        		地址
		        </Col>
		        <Col class="col center" span="9">
		        		高区测试单元1号楼2单元302
		        </Col>
		    </Row>
		    <Row>
		        <Col class="col left ivu-table-cell" span="12">
		        	购买燃气
		        	<InputNumber :max="100" :min="0.0" :step="0.1" size="small">
		        	</InputNumber>
		        	立方米，
		        	<br>
		        	合计金额
		        	<InputNumber :max="1000" :min="0.0" :step="0.01" size="small">
		        	</InputNumber>
		        	元。
		        	<br>
		        	其中
		        	<div>
		        		第一阶梯0立方米
		        	</div>
		        	<div>
		        		第二阶梯0立方米
		        	</div>
		        	<div>
		        		第三阶梯1立方米
		        	</div>
		        	<div>
		        		第四阶梯0立方米
		        	</div>
		        	<div>
		        		第五阶梯0立方米
		        	</div>
		        	<div>
		        		第六阶梯1立方米
		        	</div>
		        	剩余
		        	<div>
		        		第一阶梯0立方米
		        	</div>
		        	<div>
		        		第二阶梯0立方米
		        	</div>
		        	<div>
		        		第三阶梯1立方米
		        	</div>
		        	<div>
		        		第四阶梯0立方米
		        	</div>
		        	<div>
		        		第五阶梯0立方米
		        	</div>
		        	<div>
		        		第六阶梯1立方米
		        	</div>
		        </Col>
		        <Col class="col left ivu-table-cell" span="12">阶梯气价</Col>
		    </Row>
		    <Row>
		        <Col class="col bottom ivu-table-cell" span="12">
		        	合计人民币（大写）：<span>贰拾壹元伍角</span>
		        </Col>
		        <Col class="col bottom ivu-table-cell" span="12">
		        	收款人：<span>张弓长</span>
		        </Col>
		    </Row>
		</div>
	</div>
</template>

<script>
	export default {
        created() {
			this.nowDate = new Date();
		},
		date() {
			return {
				nowDate : ''
			}
		}
    }
</script>

<style>
	.div{
		border-top: 1px solid #BCBCBC;
	    border-left: 1px solid #BCBCBC;
        width:167mm;
        font-size: 12pt;
        margin:0 auto;
    }
    .col{
	    border-right: 1px solid #BCBCBC;
	    border-bottom: 1px solid #BCBCBC;
    }
    .center{
    	text-align: center;
    	height: 17mm;
    	line-height: 17mm;
    }
    .left{
    	height: 120mm;
    }
    .bottom{
    	height: 9mm;
    	line-height: 9mm;
    }
</style>